import Vue from 'vue'
import { renderer } from 'ima-svg-renderer'
import { updateVariantInList } from './variants'

// State
const state = {
  data: [],
  isDirty: false,
  isSaving: false
}

// Mutations
export const updateLabel = 'updateLabel'
export const removeLabel = 'removeLabel'

export const updateLabels = 'updateLabels'
export const clearLabels = 'clearLabels'
const saveLabelsRequest = 'saveLabelsRequest'
const saveLabelsResponse = 'saveLabelsResponse'

const mutations = {
  [updateLabels] (state, labels) {
    state.data = renderer.mergeLabels(state.data, labels)
  },
  [clearLabels] (state) {
    state.data = []
  },
  [updateLabel] (state, { name, value }) {
    const index = state.data.findIndex(label => label.name === name)
    state.isDirty = true
    state.data[index].value = value
  },
  [saveLabelsRequest] (state) {
    state.isSaving = true
  },
  [saveLabelsResponse] (state) {
    state.isDirty = false
    state.isSaving = false
  }
}

// Actions
let debounce = null
export const saveLabels = 'saveLabels'
const actions = {
  [saveLabels]: ({ commit, state, rootState, dispatch }, update = false) => {
    if (debounce) {
      clearTimeout(debounce)
    }

    const save = () => {
      const variantId = rootState.variant.data.id
      const labels = state.data
        .filter(({ name }) => name !== 'slogan')
        .map(({ name, value }) => ({
          name,
          value: value.length === 0 ? null : value
        }))

      commit(saveLabelsRequest)
      return Vue.http
        .post(`${SERVER_URL}/labels`, {
          variantId,
          labels
        })
        .then(({ data: labels }) => {
          commit(saveLabelsResponse)
          commit(updateVariantInList, { id: variantId, labels })
          if (update) {
            commit(updateLabels, labels)
          }
        })
    }

    return new Promise((resolve, reject) => {
      debounce = setTimeout(() => save().then(resolve), 500)
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/labels.js